import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from "react-router-dom"
import { debounce } from "lodash"

import {
    fetchDivisions,
    selectDivisions,
    selectPagination,
    selectTotal,
    selectDivisionSearch,
    searchDivisions
} from '../../../divisions/divisionsSlice'

import PaginatedSelect from '../../../forms/components/PaginatedSelect'
import { Form } from "antd"

export default function ReportDivisions() {
    const { clientId } = useParams()

    const dispatch = useDispatch()

    const pagination = useSelector(selectPagination)
    const divisions  = useSelector(selectDivisions)

    const handleSearch = debounce((value) => {
        // make sure they've typed at least 3 characters
        if (value && value.length >= 3) {
            dispatch(searchDivisions(value))
        }
    }, 1000)

    return (
        <div>
            <Form.List name="form_data">
                {
                    fields => (
                        <Form.Item label="Division" name="division_ids">
                            <PaginatedSelect
                                mode='multiple'
                                placeholder="Search divisions..."
                                onSearch={handleSearch}
                                paginationSelector={selectDivisions}
                                paginationTotalSelector={selectTotal}
                                loadPaginatedData={(p) => fetchDivisions(p, `clients/${clientId}/divisions`)}
                                searchSelector={selectDivisionSearch}
                                name='divisions'
                            />
                        </Form.Item>
                    )
                }
            </Form.List>
        </div>
    )
}
